import zhCN from 'element-ui/lib/locale/lang/zh-CN';

// 简体中文(中国)
export default {
  ...zhCN,
  lang: {
    zh_CN: '简体中文(中国)',
    en_US: 'English (United States)',
    fr_FR: 'français (France)',
    de_DE: 'Deutsch (Deutschland)',
    it_IT: 'italiano (Italia)',
    es_ES: 'español (España)',
    ru_RU: 'Русский (Россия)',
    tr_TR: 'Türkçe (Türkiye)',
    pt_BR: 'português (Brasil)',
    th_TH: 'ไทย (ภาษาไทย)',
    es_MX: 'español (México)',
    ja_JP: '日本語 (日本)',
    pl_PL: 'polski (Polska)',
    in_ID: 'Bahasa Indonesia (Indonesia)',
    my_MM: 'Burmese (Myanmar)',
    ar_SA: 'العربية (المملكة العربية السعودية )',
    vi_VN: 'Tiếng Việt (Việt Nam)',
    fa_IR: 'فارسی (ایران)',
    en_MY: 'English (Malaysia)',
  },
  layout: {
    title: 'Uniportal账号登录',
    tip: '未注册的手机号登录成功后将自动注册', // 机翻
    line: '其他登录方式',
  },
  button: {
    submit: '登录/注册', // 机翻
    getCode: '获取验证码',
    emailRegister: '邮箱注册',
    w3Login: 'W3账号登录',
    employeeLogin: '员工登录',
    passwordLogin: '密码登录',
    reSend: '重新获取',
    problem: '遇到问题',
    privacyPolicy: '隐私政策',
  },
  placeholder: {
    phoneNumber: '手机号',
    verificationCode: '短信验证码',
  },
  dialog: {
    imgCode: '请输入图形验证码',
    userAgreements: {
      header: '用户协议及隐私声明',
      text1: '请阅读并同意{privacy}和{agreement}',
      text2: '个人信息在访问华为海外应用时，将传输华为海外子公司进行处理，详情可参阅{privacy}',
    },
    crossBorder: {
      header: '授权提示',
      text: '您使用的本地服务和您账号注册地不在同一地区。涉及跨境访问账号信息，需要得到您的授权。',
    },
    multiAccounts: '请选择您本人的账号',
    agreeButton: '同意并继续',
    disagreeButton: '不同意',
    confirmButton: '确认',
    cancelButton: '取消',
    knowMe: '我知道了',
  },
  toast: {
    hasSend: '验证码已发送',
    wait: '请稍等',
  },
  tooltip: {
    Huawei: '华为账号',
    Tencent: 'QQ',
    Wechat: '微信',
    Weibo: '微博',
    Google: '谷歌',
    Facebook: '脸书',
    Linkedin: '领英',
  },
  errorCode: {
    // 图形验证码错误
    'IDC-00-00013': '图形验证码不能为空',
    'IDC-03-0002': '图形验证码已失效',
    'IDC-00-0004': '图形验证码错误',

    // 表单输入为空
    'IDC-01-00024': '手机国别码为空',
    phoneNumberEmpty: '请输入手机号码',
    'IDC-03-00033': '请输入短信验证码',

    // 表单数据错误
    'IDC-02-00227': '输入的手机号与所选国家/地区不匹配',
    'IDC-02-00226': '国家码已禁止使用',
    'IDC-02-00029': '验证码错误或已过期',
    'IDC-02-0013': '短信登录失败，验证码错误',
    'IDC-02-0020': '验证码验证失败',
    'IDC-02-00028': '手机号码必须是长度为6到30的数字',
    'IDC-02-00012': '手机号码错误',

    // 错误操作锁定
    accountLock: '手机号或验证码错误，还可尝试{number}次',
    accountLocked: '由于验证码错误次数太多，账号锁定{number}秒',
    operationRisk: '当前操作存在安全风险，请{number}秒后重试！', // 机翻

    // 频繁操作
    'IDC-02-00038': '60s内不能再次发送验证码',
    'IDC-02-00064': '您发送短信验证码的次数过于频繁，请24小时后重试！', // 机翻-有
    'IDC-02-00211': '当前操作存在安全风险，请稍后重试！',
    'IDC-02-00212': '您的手机号码发送短信验证码的次数过于频繁，请尝试更换手机号码或1小时后重试！',
    'IDC-02-00213': '您发送短信验证码的次数过于频繁，请24小时后重试！',
    'IDC-02-00215':
      '您的手机号码发送短信验证码的次数过于频繁，请尝试更换手机号码、选择其他验证方式或者1小时后重试！',
    'IDC-02-00228': '您发送短信验证码的次数过于频繁，请1小时后重试！',
    'IDC-02-00092': '当前操作过于频繁，请24小时后重试', //机翻

    // 请求异常
    'IDC-10-00400': '客户请求异常',
    'IDC-02-00264': '禁止未经授权的访问请求',
    'IDC-02-00063': '参数非法',
    'IDC-03-0007': '当前操作存在安全风险，暂时无法注册。', // 机翻
    'IDC-03-00057': '当前操作存在安全风险。',
    'IDC-10-00500': '系统内部错误',

    // 页面过期
    'IDC-00-00017': '页面已过期',
  },

  // 注册协议、隐私声明对话框
  backButton: '返回',
  closeButton: '关闭',

  // 滑块验证相关：
  resourceReqFailed: '资源请求失败，请刷新页面后重试', // 机翻
  verifyFailedAndPlsRetry: '验证失败，请重试', // 机翻
  serviceErrAndPlsRetry: '服务异常，请重试', // 机翻
  learnMore: '了解更多', // 机翻
  cookieBannerText: '本网站使用 Cookie 功能，为您提供最佳的用户体验。', // 机翻
};
